module.exports = __webpack_public_path__ + "static/media/nptel_logo.cd7077f7.png";